"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var Toggle = exports.Toggle = /*#__PURE__*/function (_React$Component) {
  _inherits(Toggle, _React$Component);
  function Toggle(props) {
    var _this;
    _classCallCheck(this, Toggle);
    _this = _callSuper(this, Toggle, [props]);
    var selectedValue = _this.props.selectedValue;
    _this.state = {
      selectedValue: selectedValue,
      errorMsg: null
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Toggle, [{
    key: "handleChange",
    value: function handleChange(event) {
      var selectedValue = event.target.value;
      this.setState({
        selectedValue: selectedValue,
        errorMsg: ''
      });
      if (this.props.changeCallback) {
        this.props.changeCallback(selectedValue);
      }
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var selectedValue = this.state.selectedValue;
      var optional = this.props.optional;
      var errorFree = true;
      if (!selectedValue && !optional) {
        this.setState({
          errorMsg: this.props.errorMsg || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "shared_components.toggle.select_option",
            defaultMessage: "Please select an option."
          })
        });
        errorFree = false;
      } else {
        this.setState({
          errorMsg: ''
        });
      }
      return errorFree;
    }
  }, {
    key: "checkForError",
    value: function checkForError() {
      var errorMsg = this.state.errorMsg;
      if (errorMsg) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "help-block inline-help text-danger text-left"
        }, errorMsg);
      }
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var title = this.props.title;
      if (title) {
        return /*#__PURE__*/_react.default.createElement("h5", null, title);
      }
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var label = this.props.label;
      if (label) {
        return /*#__PURE__*/_react.default.createElement("label", {
          className: "control-label text-left vert-align-label"
        }, label);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var selectedValue = this.state.selectedValue;
      var _this$props = this.props,
        onValue = _this$props.onValue,
        offValue = _this$props.offValue,
        onLabel = _this$props.onLabel,
        offLabel = _this$props.offLabel,
        colSize = _this$props.colSize;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-12"
      }, this.renderTitle(), this.renderLabel()), /*#__PURE__*/_react.default.createElement("div", {
        className: colSize
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "switch"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        className: "switch-input",
        name: "switcher",
        value: onValue,
        id: onValue,
        onChange: this.handleChange,
        checked: selectedValue === onValue
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: onValue,
        className: "switch-label switch-label-on"
      }, onLabel), /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        className: "switch-input",
        name: "switcher",
        value: offValue,
        id: offValue,
        onChange: this.handleChange,
        checked: selectedValue === offValue
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: offValue,
        className: "switch-label switch-label-off"
      }, offLabel)), this.checkForError()));
    }
  }]);
  return Toggle;
}(_react.default.Component);
Toggle.propTypes = {
  onLabel: _propTypes.default.string,
  offLabel: _propTypes.default.string,
  onValue: _propTypes.default.string,
  offValue: _propTypes.default.string,
  changeCallback: _propTypes.default.func,
  title: _propTypes.default.string,
  label: _propTypes.default.string,
  colSize: _propTypes.default.string,
  errorMsg: _propTypes.default.string,
  optional: _propTypes.default.bool
};
Toggle.defaultProps = {
  onLabel: 'On',
  offLabel: 'Off',
  onValue: 'on',
  offValue: 'off',
  selectedValue: false,
  colSize: 'col-md-12',
  optional: false
};